import React, { createContext, useContext, useSyncExternalStore } from "react";

// Phone = a viewport 639.98px wide or less (below Tailwind `sm`, the same
// line CSS draws with `max-sm:`). 640px and up, every tablet and laptop,
// keeps the regular layout.
export const PHONE_MAX_WIDTH = 639.98;
export const PHONE_QUERY = `(max-width: ${PHONE_MAX_WIDTH}px)`;

const media = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(PHONE_QUERY) : null;

const subscribe = (onChange) => {
  const m = media();
  if (!m) return () => {};
  if (m.addEventListener) m.addEventListener("change", onChange);
  else if (m.addListener) m.addListener(onChange);
  return () => {
    if (m.removeEventListener) m.removeEventListener("change", onChange);
    else if (m.removeListener) m.removeListener(onChange);
  };
};

// False without matchMedia (jsdom, old browsers): the desktop tree is the
// default. The first render reads matchMedia synchronously, so a phone never
// flashes the desktop layout.
export const isPhoneViewport = () => Boolean(media()?.matches);
export const useIsPhone = () => useSyncExternalStore(subscribe, isPhoneViewport, () => false);

// The phone theme is only switched on inside the Athlete Mode and Coach Mode
// shells and the sign-up / onboarding frame. Brand, Rep, Supporter, Admin and
// the Player Index keep today's layout on phones, so shared components read
// usePhoneTheme(), never the raw hook.
const PhoneThemeContext = createContext(false);

export const PhoneThemeProvider = ({ children }) => (
  <PhoneThemeContext.Provider value>{children}</PhoneThemeContext.Provider>
);

export const usePhoneTheme = () => {
  const phone = useIsPhone();
  return useContext(PhoneThemeContext) && phone;
};
